import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MessageService } from 'abp-ng2-module';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { WarningPopupProjectComponent } from '../../shared/warning-popup-project/warning-popup-project.component';

@Component({
  selector: 'project-image-upload',
  templateUrl: './project-image-upload.component.html',
  styleUrls: ['./project-image-upload.component.scss']
})
export class ProjectImageUploadComponent implements OnInit {

  @Output() valueChange = new EventEmitter();
    @ViewChild('projectimgmodal', { static: true }) modal: ModalDirective;
    @ViewChild("SignModalPopup", { static: true }) SignModalPopup: WarningPopupProjectComponent;

  fileExtension: any;
  imagePathModal = '';
  showImg = true;
  showImgModal = false;
  isImage = true;
  allowedPhotoFile = ["png", "jpg", "jpeg"];
  constructor(private _messageService: MessageService) { }
  show(): void                                                                                                                                                                    {
   this.modal.show();
  }
  close() {
      this.modal.hide();
  }
  onShown(): void {
  }
  ngOnInit(): void {
  }
  public getfileContent(fileList: FileList) {
     // if (fileList[0].size < 5242880) { for image size put all code here }
          const fileUpload = document.getElementById('UploadFile') as HTMLInputElement;
          let FileName = fileList[0].name;
          this.isImage = false;
          this.fileExtension = FileName.replace(/^.*\./, '');
          this.fileExtension = FileName.replace(/^.*\./, '');
          if (!this.allowedPhotoFile.includes(this.fileExtension.toLocaleLowerCase())) {
              //show error
            //  this._messageService.error("Use only Png, Jpg or Jpeg format for Photo.");

              this.SignModalPopup.show();
              return;
          }
          for (let index = 0; index < fileUpload.files.length; index++) {
              let reader = new FileReader();
              reader.onload = (e: any) => {
                  this.imagePathModal = e.target.result;
              };
              reader.readAsDataURL(fileUpload.files[index]);
          }
          
          this.showImg = true;
          this.showImgModal = true;
  }
  savePhoto() {
      this.valueChange.emit(this.imagePathModal);
      this.modal.hide();
      this.isImage=true;
      this.showImgModal = false;
  }
  saveCancel() {
      this.modal.hide();
      this.showImgModal = false;
      this.imagePathModal = '';
  }

  removeImage() {
      this.isImage=true;
      this.showImgModal = false;
  }
}
